import { useApi } from '@/api';
import { Flex, KpiCard, KpiSkeleton } from '@blockanalitica/ui';
import { Fragment } from 'react/jsx-runtime';

type SLLIndexResponse = {
  alm_proxy_usd: string;
  alm_proxy_usd_change: string | null;
  real_apy: string;
  real_apy_change: string | null;
  total_assets_usd: string;
  total_assets_usd_change: string | null;
  aum_usd: string;
  aum_usd_change: string | null;
};

export default function KPI() {
  const [data, error] = useApi<SLLIndexResponse>({
    url: '/sparkstar/sll/'
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <KpiSkeleton />;
  }

  return (
    <Fragment>
      <Flex flexDirection={['column', 'row']} gap="s">
        <KpiCard
          title="Total Allocated Assets"
          data={{
            aum_usd: data['aum_usd'],
            aum_usd_change: data['aum_usd_change']
          }}
          field="aum_usd"
          options={{
            currency: 'USD',
            notation: 'compact'
          }}
        />
        <KpiCard
          title="Total Assets"
          data={{
            total_assets_usd: data['total_assets_usd'],
            total_assets_usd_change: data['total_assets_usd_change']
          }}
          field="total_assets_usd"
          options={{
            currency: 'USD',
            notation: 'compact'
          }}
        />

        <KpiCard
          title="APY"
          data={{
            real_apy: data['real_apy'],
            real_apy_change: data['real_apy_change']
          }}
          field="real_apy"
          options={{
            percentage: true
          }}
        />
      </Flex>
    </Fragment>
  );
}
